import { Tag } from '@components/Tag/Tag';

import { ITag } from '@models/Tag.model';

import { TruncatedText } from '@pages/Updates/components/UpdatesNew/components/TruncatedText/TruncatedText';
import {
  Container,
  DescriptionWrapper,
  NoDescription,
  Row,
  TagContainer,
} from './TagsList.styles';

export type TagInfoWDesc = Pick<ITag, 'id' | 'name' | 'description'> & {
  tagCategory?: Pick<NonNullable<ITag['tagCategory']>, 'name' | 'color'>;
};

interface ITagsList {
  tag: TagInfoWDesc;
  onClick: () => void;
  disabled?: boolean;
}

const TagsList = ({ tag, onClick, disabled }: ITagsList) => {
  return (
    <Container
      disabled={disabled}
      onClick={() => {
        // Qn: Why do we revert on click if we only eval when !Disabled
        if (!disabled) onClick();
      }}
    >
      <Row>
        <TagContainer>
          <Tag
            id={tag.id}
            tagName={tag.name}
            tagCategory={tag.tagCategory?.name}
            color={tag.tagCategory?.color}
          />
        </TagContainer>

        {tag.description ? (
          <DescriptionWrapper>
            <TruncatedText color="#696F8C">{tag.description}</TruncatedText>
          </DescriptionWrapper>
        ) : (
          <NoDescription>No description</NoDescription>
        )}
      </Row>
    </Container>
  );
};

export { TagsList };
